import { createFileRoute, redirect } from '@tanstack/react-router'
import { isPublicKbHost } from '../../../lib/public-kb-host'
import { z } from 'zod'
import { KnowledgeSettingsPage } from '../../../components/knowledge/settings/KnowledgeSettingsPage'
import { SETTINGS_SECTIONS } from '../../../components/knowledge/settings/KnowledgeSettingsShell'

const settingsSearchSchema = z.object({
  section: z.enum(SETTINGS_SECTIONS).catch('public-site'),
})

export const Route = createFileRoute('/knowledge/$workspaceId/settings')({
  beforeLoad: () => {
    if (isPublicKbHost()) {
      throw redirect({ to: '/knowledge' })
    }
  },
  validateSearch: settingsSearchSchema,
  component: KnowledgeSettingsRoutePage,
})

function KnowledgeSettingsRoutePage() {
  const { workspaceId } = Route.useParams()
  const { workspace } = Route.useRouteContext()
  const { section } = Route.useSearch()

  return (
    <KnowledgeSettingsPage
      workspace={workspace}
      workspaceId={workspaceId}
      activeSection={section}
    />
  )
}
